import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

//MUI Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Alert from '@mui/material/Alert';

//created components

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getAccess } from "../../../../../../store/selectors.js"; //global state : shopping state
import { accessoiresSlice } from "../../../../../../store/accessoiresSlice.js";

//Utils :





function ContratAccess({ access }) { // component to manage the first step of shopping : choosing place and time


    let accessList = useSelector(getAccess);
    const dispatch = useDispatch();



    function getQte() {
        let currentAccess = accessList.filter((ligne) => ligne.id_article === access.id_article)
        if (currentAccess.length > 0) {//"ligne" represent an access in the accessList
            return (currentAccess[0].qte);
        }
        else {
            return (0);
        }
    }

    function handleChangeQte(delta) {
        let qte = getQte();

        if (qte === 0) { //access non present in accessList
            if (delta === "plus") { //add new access
                dispatch(accessoiresSlice.actions.newAccess(access));
            }
        }// end of new access

        if (qte === 1) { //jusT 1 access  present in panier
            if (delta === "plus") { //increment access
                dispatch(accessoiresSlice.actions.incrementAccess(access));
            }
            if (delta === "moins") { //remove  access
                dispatch(accessoiresSlice.actions.removeAccess(access));
            }
        }

        if (qte > 1) { //jusT 1 access  present in panier
            if (delta === "plus") { //increment access
                dispatch(accessoiresSlice.actions.incrementAccess(access));
            }
            if (delta === "moins") { //decrement  access
                dispatch(accessoiresSlice.actions.decrementAccess(access));
            }
        }



    }





    return (
        <div className={getQte() > 0 ? "cadre-access cadre-access-selected" : "cadre-access "}>
            <div className="cadre-article-left">
                <div className="cadre-article-left-top">
                    <img src={access.image_url} alt="image vélo" />
                </div>



                <div className="cadre-article-left-bottom">
                    <div className="boutons-qte">
                        <Button
                            /* disabled={dsbld} */
                            variant="contained"
                            /* onClick={nextStep} */
                            className="boutons-qte-moins" //stylise in css
                            style={{ maxWidth: '50px', maxHeight: '36px', minWidth: '50px', minHeight: '36px' }}
                            onClick={() => { handleChangeQte("moins") }}
                        > - </Button>
                        <p className="boutons-qte-valeur">{getQte()}</p>
                        <Button

                            variant="contained"
                            /* onClick={nextStep} */
                            className="boutons-qte-plus" //stylise in css
                            style={{ maxWidth: '50px', maxHeight: '36px', minWidth: '50px', minHeight: '36px' }}
                            onClick={() => { handleChangeQte("plus") }}
                        > + </Button>

                    </div>
                </div>
            </div>
            <div className="cadre-article-center">
                <div className="cadre-article-center-top">
                    <div className="cadre-article-center-top-titre">
                        <h3>{access.type}</h3>

                    </div>
                    <div className="cadre-article-center-top-description">
                        <h4>{access.infos}</h4>
                        <p className="cadre-article-center-top-description-infos2">{access.infos2}</p>
                        <p className="cadre-article-center-top-description-description">{access.description}</p>

                    </div>
                </div>
                <div className="cadre-article-center-bottom">
                    <div className="cadre-article-center-bottom-haut">


                    </div>
                    <div className="cadre-article-center-bottom-main">

                    </div>
                </div>
            </div>



        </div>

    )
}




export default ContratAccess